import { Button } from '@busybusy/webapp-react-ui';
import classNames from 'classnames';
import HeaderDialog from 'components/foundation/dialogs/HeaderDialog/HeaderDialog';
import { t } from 'i18next';
import { ClassName } from 'types/ClassName';

export interface IEquipmentGpsDeviceAlreadyAssignedDialogProps {
  className?: ClassName;
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const EquipmentGpsDeviceAlreadyAssignedDialog = (props: IEquipmentGpsDeviceAlreadyAssignedDialogProps) => {
  const { className, isOpen, onClose, onSubmit } = props;

  const classes = classNames('equipment-gps-device-already-assigned-dialog', className);

  return (
    <HeaderDialog className={classes} title={t('Tracking Device Already Assigned')} isOpen={isOpen} onClose={onClose}>
      <div className={'m-4'}>
        <div>
          {t('This GPS device is already assigned to another piece of equipment. Please choose a different device.')}
        </div>
        <Button className="mt-4 mr-2" type="primary" onClick={onSubmit}>
          {t('Transfer Device')}
        </Button>
        <Button className="mt-4" type="secondary" onClick={onClose}>
          {t('Cancel')}
        </Button>
      </div>
    </HeaderDialog>
  );
};

export default EquipmentGpsDeviceAlreadyAssignedDialog;
